import { render, staticRenderFns } from "./contactusPage.vue?vue&type=template&id=82eb1590&"
import script from "./contactusPage.vue?vue&type=script&lang=js&"
export * from "./contactusPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports